import { c as _c } from "react/compiler-runtime";
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import { ReactElement, ReactNode } from 'react';
import Div100vh from 'react-div-100vh';
import { ThemeProvider } from '@core/shared/ui/ThemeProvider';
// Used to resolve dynamic viewport height on Safari
import { ThemeMode, ThemeName } from '@core/shared/ui/themes';
import { Footer } from '../Footer';
import { Header } from '../Header';
interface PageWrapperProps {
  hero?: ReactNode;
  children?: ReactNode;
  hideHeader?: boolean;
  hideHeaderSpacer?: boolean;
  hideHeaderTabButtons?: boolean;
  testId?: string;
  headerThemeMode?: ThemeMode;
  hideFooter?: boolean;
  isFullscreen?: boolean;
  showLanguageSwitcher?: boolean;
}
export function PageWrapper(t0) {
  const $ = _c(24);
  const {
    hero,
    children,
    hideHeader,
    hideHeaderSpacer,
    hideHeaderTabButtons,
    testId,
    headerThemeMode,
    hideFooter: t1,
    isFullscreen: t2,
    showLanguageSwitcher: t3
  } = t0;
  const hideFooter = t1 === undefined ? false : t1;
  const isFullscreen = t2 === undefined ? false : t2;
  const showLanguageSwitcher = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== headerThemeMode || $[1] !== hideHeader || $[2] !== hideHeaderSpacer || $[3] !== hideHeaderTabButtons || $[4] !== showLanguageSwitcher) {
    t4 = hideHeader !== true && <Header themeMode={headerThemeMode} hideSpacer={hideHeaderSpacer} hideTabButtons={hideHeaderTabButtons} showLanguageSwitcher={showLanguageSwitcher} />;
    $[0] = headerThemeMode;
    $[1] = hideHeader;
    $[2] = hideHeaderSpacer;
    $[3] = hideHeaderTabButtons;
    $[4] = showLanguageSwitcher;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = isFullscreen ? "hidden" : "clip";
  let t6;
  if ($[6] !== t5) {
    t6 = {
      justifyContent: "space-between",
      width: "100%",
      height: "100%",
      overflowX: t5
    };
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== hero) {
    t7 = <Container maxWidth={false} disableGutters={true}><ThemeProvider nested={true} themeName={ThemeName.website} themeMode={ThemeMode.dark}>{hero}</ThemeProvider></Container>;
    $[8] = hero;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      flexGrow: 1
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== children) {
    t9 = <Box sx={t8}>{children}</Box>;
    $[11] = children;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== hideFooter) {
    t10 = hideFooter !== true && <Footer />;
    $[13] = hideFooter;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t6 || $[17] !== t7 || $[18] !== t9 || $[19] !== testId) {
    t11 = <Stack data-testid={testId} sx={t6}>{t7}{t9}{t10}</Stack>;
    $[15] = t10;
    $[16] = t6;
    $[17] = t7;
    $[18] = t9;
    $[19] = testId;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t4) {
    t12 = <Div100vh>{t4}{t11}</Div100vh>;
    $[21] = t11;
    $[22] = t4;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
}